module.exports = __webpack_public_path__ + "static/media/img_5.a5438163.png";